import { BulkAssignmentCase, CaseUserGroup, CaseUserGroupNames } from '@/api/apis/case';
import { BulkAssignmentFiltersType } from './types';
import { BULK_ASSIGNMENT_COLUMNS, DISABLED_DETACH_ONLY_GROUPS } from './constants';

export const isDisabledDetachOnly = (filters: BulkAssignmentFiltersType) => {
  return (
    DISABLED_DETACH_ONLY_GROUPS.includes(filters.group[0]) &&
    filters.employeeIdsToDetach.length > 0 &&
    filters.employeeIdsToAssign.length === 0
  );
};

export const getActionByFiltersState = (filters: BulkAssignmentFiltersType) => {
  const hasDetach = filters.employeeIdsToDetach.length > 0;
  const hasAssign = filters.employeeIdsToAssign.length > 0;

  if (hasDetach && hasAssign) return 'Swap';
  if (hasAssign) return 'Assign';
  if (hasDetach) return 'Detach';
  return 'Swap';
};

export const getDisabledKeys = (filters: BulkAssignmentFiltersType, items: BulkAssignmentCase[] = []) => {
  if (isDisabledDetachOnly(filters)) {
    return (
      items
        .filter((item) => {
          const users = item.assignedEmployees?.[filters.group[0]] || [];
          return users.length === 1;
        })
        .map((item) => item.caseId) || []
    );
  }
  return [];
};

export const getTableColumns = (group?: CaseUserGroup) => {
  if (group) {
    return [...BULK_ASSIGNMENT_COLUMNS, { key: 'users', label: CaseUserGroupNames[group], isSortable: false }];
  }

  return BULK_ASSIGNMENT_COLUMNS;
};
